import React from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Wrapper from '../../components/templates/SchoolWrapper';
import Title from '../../components/Service/SchoolTeachers/Title';
import NumberSection from '../../components/Service/SchoolTeachers/Number';
import Certified from '../../components/Service/SchoolTeachers/Certified';
import Improving from '../../components/Service/SchoolTeachers/Improving';

const SchoolTeachersMain = (_props) => {
  const { t } = useTranslation('common');
  return (
    <Wrapper>
      <>
        <Head>
          <title>{t('title.school.certifiedTeachers')}</title>
          <meta
            name="description"
            content={t('service.school.certifiedTeachers.intro')}
          />
        </Head>
        <div className="school-main-content">
          <Title />
          <NumberSection />
          <Certified />
          <Improving />
        </div>
      </>
    </Wrapper>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default SchoolTeachersMain;
